// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7b417ada","299":"bd878f70","353":"3c8c717e","435":"57a55eb9"}[chunkId] + ".chunk.js";
};